import { chain, createToggler } from '@leprecoins/effector';
import { createEvent, createStore, sample } from 'effector';
import { combineEvents, delay } from 'patronum';
import { gameModel } from 'entities/game';
import { getSettingsQuery, receiveSession } from 'shared/api';
import {
	LOADER_LOGO_DURATION,
	LOADER_PROGRESS_TRANSITION_DURATION,
	LOADER_TRANSITION_DURATION,
} from '../config';

export const LOADER_STAGES = {
	init: 'init',
	logo: 'logo',
	progress: 'progress',
	progressFulfill: 'progress-fulfill',
	play: 'play',
} as const satisfies Record<string, string>;

export type LoaderStage = (typeof LOADER_STAGES)[keyof typeof LOADER_STAGES];

const toggler = createToggler(true);

const $stage = createStore<LoaderStage>(LOADER_STAGES.init);

const $progress = createStore(0);

const mounted = createEvent();

const logoEnter = mounted;

const logoExit = delay(logoEnter, LOADER_LOGO_DURATION);

const progressEnter = logoExit;

const progressEntered = delay(progressEnter, LOADER_TRANSITION_DURATION);

const progressIncrease = delay(progressEntered, LOADER_TRANSITION_DURATION);

const progressFulfill = combineEvents([
	delay(progressIncrease, LOADER_PROGRESS_TRANSITION_DURATION),
	receiveSession.success,
	getSettingsQuery.finished.success,
	gameModel.assetsLoaded,
]);

const progressExit = delay(progressFulfill, LOADER_PROGRESS_TRANSITION_DURATION);

const playEnter = progressExit;

sample({
	clock: [
		logoEnter.map(() => LOADER_STAGES.logo),
		progressEnter.map(() => LOADER_STAGES.progress),
		progressFulfill.map(() => LOADER_STAGES.progressFulfill),
		playEnter.map(() => LOADER_STAGES.play),
	],
	target: $stage,
});

sample({
	clock: [progressIncrease.map(() => 66.6), progressFulfill.map(() => 100)],
	target: $progress,
});

chain(toggler.disabled, gameModel.loaderClosed);

export const loaderModel = {
	toggler,
	$stage,
	$progress,
	mounted,
};
